import YesIcon from 'assets/images/yes-icon.svg';
import SuccessImage from 'assets/images/create-success.svg';
import CancelRenewalImage from 'assets/images/cancel-renewal-v2.svg';
import CanceSubslImage from 'assets/images/sad-smiley.svg';
import ThumbsupImage from 'assets/images/thumbsup-smiley.svg';
import Logo from 'assets/images/logo.svg';
import FooterLogo from 'assets/images/footer-logo.svg';
import LoginLogo from 'assets/images/login-logo.svg';
import Theme from 'theme';

const {
  REACT_APP_GROUP_ID: groupId,
  REACT_APP_AWS_REGION: region,
  REACT_APP_COGNITO_POOL_ID: userPoolId,
  REACT_APP_COGNITO_WEB_CLIENT_ID: userPoolWebClientId,
  REACT_APP_CLIENT_HEADER: clientHeader = groupId,
  REACT_APP_APPPOINTMENT_LINK: bookAppointmentLink,
} = process.env;

const config = {
  groupId,
  region,
  userPoolId,
  userPoolWebClientId,
  logo: Logo,
  cptCodesIcon: YesIcon,
  portalName: 'Mattson Hellickson Dental',
  tokenName: 'mattsonhellicksonSubscriberToken',
  globalClass: 'group-parent-container',
  clientHeader,
  enableHeroButton: true,
  pricingType: 'standard-pricing',
  showAddressSuggestion: true,
  heroLocaleColor: 'secondary',
  splitPlans: true,
  headerProps: {
    enable: true,
  },
  localeProps: {},
  homeTemplateProps: {
    heroSection: {
      variant: 2,
      alignContent: 'center',
      titleClasses: 'home-hero-title',
      subTitleClasses: 'home-hero-subtitle',
      primaryButtonProps: {
        to: '/find-a-provider',
      },
      secondaryButtonProps: {
        to: '/login',
        color: 'primary',
        variant: 'outlined',
      },
      background: '/images/home-images/home-banner-img.webp',
      backgroundMobile: '/images/home-images/home-banner-img-mobile.webp',
    },
    benefitsSection: {
      variant: 2,
      columns: 3,
      alignTitle: 'left',
      alignCard: 'center',
    },
    subscriptionSection: {
      priority: 'top',
      renderAsTabsLimit: 3,
      cardVariant: 1,
      tabVariant: 1,
      disableGroupSavings: true,
      plansPerRow: { xs: 1, sm: 1, md: 3, lg: 3 },
      carouselResponsiveItems: {
        desktop: 3,
        tablet: 1,
      },
      showAddons: false,
      primaryButtonProps: {
        color: 'primary',
      },
      planCardProps: {
        buttonProps: {
          customSpace: 11,
          normalVariant: 'contained',
          normalColor: 'primary',
          to: '/find-a-provider',
        },
      },
    },
    howItWorksSection: {
      variant: 2,
      heroImage: '/images/home-images/how-it-works.webp',
      alignTitle: 'left',
    },
    testimonialSection: {
      enable: false,
    },
    staticHeroSection: {
      enable: true,
      variant: 1,
      primaryButtonProps: {
        color: 'primary',
      },
    },
  },
  checkoutSection: {},
  findProviderSection: {
    locationWrapper: 7,
    mapWrapper: 5,
    iconProps: {
      url: '/images/map-loc-icon.svg',
    },
    heroProps: {
      primaryButtonProps: {
        enable: true,
      },
      secondaryButtonProps: {
        enable: true,
      },
    },
  },
  choosePlanSection: {
    sectionSubtitle: '',
    locationLogo: Logo,
    cardVariant: 1,
    tabVariant: 2,
    planCardProps: {
      buttonProps: {
        normalColor: 'primary',
        highlightedColor: 'primary',
        normalVariant: 'contained',
        highlightedVariant: 'outlined',
      },
    },
    staticHeroSection: {
      enable: true,
      variant: 1,
      primaryButtonProps: {
        color: 'primary',
      },
    },
  },
  subscriptionSuccess: {
    successImage: SuccessImage,
    enableBookAppointment: false,
  },
  savingsSummary: {
    enableFooterbar: true,
    showCategoryHeaders: true,
    showPlanDiscHeader: true,
    contactSection: 'contactDetails',
    buttonProps: {
      variant: "outlined",
      color: "secondary",
      size: "large",
    },
    heroProps: {
      primaryButtonProps: {
        enable: true,
      },
      secondaryButtonProps: {
        enable: true,
        variant: 'outlined',
        color: 'secondary',
      },
    },
  },
  faqSection: {
    heroProps: {
      primaryButtonProps: {
        enable: true,
      },
      secondaryButtonProps: {
        enable: true,
        variant: 'outlined',
        color: 'secondary',
      },
    },
  },
  dashboardProps: {
    showBenefitsUsage: true,
    cancelRenewal: {
      image: CancelRenewalImage,
    },
    cancelSubscription: {
      image: CanceSubslImage,
    },
    reactivateRenewal: {
      image: ThumbsupImage,
    },
  },
  bookAppointment: {},
  footer: {
    enable: true,
    logo: FooterLogo,
  },
  loginPage: {
    bannerImage: './images/login.webp',
    logo: LoginLogo,
  },
  theme: Theme,
};

export default config;
